<template>
  <div></div>
</template>

<script>
import { request } from "@/api/all";
import { mapActions } from "vuex";
import { setToken } from "@/libs/util";

export default {
  ...mapActions(["handleLoading"]),
  methods:{
    ...mapActions([
      "handleLogin",
      "handleLoginGolomt",
      "handleUserInfo",
      "handleLoading",
      "handleLogOut",
      "handleDynamicMenuLoaded",
      "handleSnackbar",
      "handleGroupSettings",
      "handleUsersettings",
      "handleGroupDefaultProjects",
      "handleRoutes",
      "handleSignalR",
      "handlePersonalSettings",
      "handleActiveGroup",
    ]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
  },
  mounted(){
    this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "User/DLLoginAPI" },
        data: { token: this.$route.params.token },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        
        if (res != false) {
          //console.log('res', res);
          setToken(res.token);

          this.handleUserInfo({ store: this.$store }).then((irs) => {
            if (irs != false) {
              this.handleGroupSettings({ store: this.$store }).then((stt) => {
                if (stt != false) {
                  this.handleUsersettings({ store: this.$store }).then((ustt) => {
                    if (ustt != false) {
                      this.handleGroupDefaultProjects({
                        store: this.$store,
                      }).then((res) => {
                        if (res != false) {
                          this.handleRoutes({ router: this.$router })
                            .then(() => {
                              this.handleSignalR()
                                .then(() => {
                                  this.handleLoading({ isLoading: false });

                                  this.$router.push("/home");
                                })
                                .catch(() => {
                                  this.handleLoading({ isLoading: false });
                                  this.$bvToast.toast(
                                    `Мессеж хүлээн авах сокетын холболт амжилтгүй боллоо.`,
                                    {
                                      title: "Мэдэгдэл",
                                      autoHideDelay: 15000,
                                      appendToast: true,
                                    }
                                  );
                                  this.$router.push("/home");
                                });
                            })
                            .catch((ex) => {
                              //console.log(ex);
                              this.$bvToast.toast(
                                `Алдаатай хүсэлт ирлээ. Системийг ахин ачааллана уу.`,
                                {
                                  title: "Мэдэгдэл",
                                  autoHideDelay: 15000,
                                  appendToast: true,
                                }
                              );
                              this.handleLoading({ isLoading: false });
                            });
                        }
                      });
                    }
                  });
                }
              });
            }
          });
          
        }else{
          this.$router.push({ name: "login" });
        }
      });
  }
}
</script>

<style>

</style>